module.exports = __webpack_public_path__ + "img/0xE3F5a90F9cb311505cd691a46596599aA1A0AD7D.960dfd0d.png";